var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.designerMode)?_c('div',{attrs:{"data-designer-droppable":"default","data-designer-skip-slot-template":"1","data-designer-custom-name":"Content"}}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }